import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FeedbackLinks from '../FeedbackLinks/FeedbackLinks';
import Modal from '@homeaway/react-modal';
import FeedbackTab from '../FeedbackTab/FeedbackTab';
import SiteFeedback from '../../utils/SiteFeedback';
import {TrackingContext} from '@homeaway/react-event-tracking';

class Feedback extends Component {
    static propTypes = {
        /** Object containing translations for the current locale. It is assumed that the parent app will prepare and provide the object matching the shape seen here. */
        l10n: PropTypes.shape({
            tabText: PropTypes.string,
            title: PropTypes.string,
            reviewLink: PropTypes.string,
            reviewLinkText: PropTypes.string,
            helpLink: PropTypes.string,
            helpLinkText: PropTypes.string,
            supportLinkText: PropTypes.string,
            externalLinkSrText: PropTypes.string
        }),
        /** Desired position on screen to render the feedback tab. Valid options are: left, right, and bottom */
        tabPosition: PropTypes.oneOf(['bottom', 'right', 'left']),
        /** allows consuming app to customize the feedback tab via a string of classnames that will be applied to the feedback tab */
        feedbackTabClassList: PropTypes.string,
        /** Disable rendering of site feedback option. */
        disableSiteFeedback: PropTypes.bool
    };

    static defaultProps = {
        l10n: {
            tabText: 'Feedback',
            title: 'Feedback',
            reviewLink:
                'https://help.homeaway.com/articles/How-do-I-submit-a-review',
            reviewLinkText: 'I would like to leave a review for a property',
            helpLink: 'https://help.homeaway.com/',
            helpLinkText:
                'I have an issue or question and would like some help',
            supportLinkText: 'I want to leave a comment for this web site',
            externalLinkSrText: 'Opens in a new window'
        },
        tabPosition: 'bottom',
        feedbackTabClassList: 'Feedback__tab btn btn-default',
        disableSiteFeedback: false
    };

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    componentDidMount() {
        this.siteFeedback = new SiteFeedback();
        this.eventPresented('feedback.presented');
    }

    static contextType = TrackingContext;

    eventHidden = () => {
        if (this.context.hasProvider) {
            this.context.trigger('feedback.hidden');
        }
    };

    eventPresented = () => {
        if (this.context.hasProvider) {
            this.context.trigger('feedback.presented');
        }
    };

    eventSelected = () => {
        if (this.context.hasProvider) {
            this.context.trigger('feedback.selected');
        }
    };

    handleOpen = () => {
        this.handleOpenAndLoad();
    };

    handleOnPress = (e) => {
        const code = e.charCode || e.keyCode;
        if (code === 32 || code === 13) {
            // Check if enter key or space bar were pressed
            this.handleOpenAndLoad();
        }
    };

    handleClose = () => {
        this.setState({isOpen: false});
        this.eventHidden();
    };

    handleOpenAndLoad = () => {
        const currentisOpen = this.state.isOpen;

        this.setState({isOpen: !currentisOpen});
        this.eventSelected();
    };

    setDialogFocus = () => {
        if (typeof document !== 'undefined') {
            document.getElementById('react-feedback').focus();
        }
    };

    render() {
        const {
            className,
            disableSiteFeedback,
            feedbackTabClassList,
            l10n,
            lingua,
            tabPosition
        } = this.props;

        const translations = lingua ? lingua : l10n;

        return (
            <FeedbackTab
                isOpen={this.state.isOpen}
                onClick={this.handleOpen}
                onPress={this.handleOnPress}
                tabText={translations.tabText}
                tabPosition={tabPosition}
                feedbackTabClassList={feedbackTabClassList}
                className={className}
            >
                <Modal
                    id="react-feedback"
                    isOpen={this.state.isOpen}
                    onClose={this.handleClose}
                    onModalOpen={this.setDialogFocus}
                    title={translations.title}
                >
                    <FeedbackLinks
                        l10n={translations}
                        siteFeedback={this.siteFeedback}
                        disableSiteFeedback={disableSiteFeedback}
                    />
                </Modal>
            </FeedbackTab>
        );
    }
}

export default Feedback;
